import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from 'react-toolbox/lib/input';
import styles from './input.scss';

function SunbitInput(props) {
  const {children, fullWidth, ...restProps} = props;
  const className = classNames({[styles['fullWidth']]: fullWidth}, restProps.className);

  return (
    <Input {...restProps} className={className}>
      {children}
    </Input>
  );
}

SunbitInput.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
};

export default SunbitInput;



// WEBPACK FOOTER //
// ./src/components/common/material/Input.js